import React, { Fragment } from 'react';
import { Reorder } from 'framer-motion';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import PAUTScanData from '../../forms/custom-paut/pautScanData';
import ReorderItem from '../../common/reorderItem';

import { PDFImageProps } from '../../../utils/models';

export interface PAUTScanDataItem {
    id: number;
    weldNumber: string;
    scanNumber: string;
    aScan: PDFImageProps[],
    sScan: PDFImageProps[],
    cScan: PDFImageProps[],
    thickness: number;
    pipeDia: number;
    scanStart: number;
    scanEnd: number;
    defectType: string;
    defectDepth: number;
    defectLength: number;
    defectHeight: number;
    minimumMeasuredThickness: number;
    result: string;
    limitation: string;
    remark: string;
}
interface Props {
    pautScanDataItems: PAUTScanDataItem[];
	onDataChange: (items: PAUTScanDataItem[]) => void;
}

const PAUTScanDataItems: React.FC<Props> = (props) => {
	const handleAddItem = (item: PAUTScanDataItem) => {
        const newItem = { ...item, id: props.pautScanDataItems.length + 1 };
		props.onDataChange([...props.pautScanDataItems, newItem]);
	};

	const handleDeleteItem = (item: PAUTScanDataItem): void => {
		const newAnomalyItems = props.pautScanDataItems.filter((pautItem) => pautItem.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (originalItem: PAUTScanDataItem, updatedItem: PAUTScanDataItem): void => {
        const updatedItems = props.pautScanDataItems.map((pautItem) => pautItem.id === originalItem.id ? updatedItem : pautItem);
		props.onDataChange(updatedItems);
	};

	return (
		<Fragment>
            <CustomNewItem label='Add New PAUT Scan Data'>
                <PAUTScanData onSave={handleAddItem} />
            </CustomNewItem>

			<div className="divider my-4"></div>

            <Reorder.Group className='list-unstyled' values={props.pautScanDataItems} onReorder={props.onDataChange}>
                {props.pautScanDataItems.map((item) => (
                    <ReorderItem key={item.id} value={item}>
                        <AccordionItem key={item.id} title={item.weldNumber + ' ' + item.scanNumber} isActive isOpenOnDefault={false}>
                            <PAUTScanData
                                initialPautItem={item}
                                onDeleteItem={() => handleDeleteItem(item)}
                                onSave={(updatedItem: PAUTScanDataItem) => handleEditItem(item, updatedItem)} 
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
		</Fragment>
	);
};

export default PAUTScanDataItems;